import styled from 'styled-components';

import { breakpoint } from '@ovpn/ui/tokens';

export const AppWrapper = styled.div`
    position: relative;

    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    max-width: 100%;
    height: 100%;
    margin-top: var(--notification-top-offset, 0);
    padding: 32px;

    @media (max-width: ${breakpoint.md}px) {
        padding: 32px 24px;
    }

    @media (max-width: ${breakpoint.sm}px) {
        padding: 32px 16px;
    }
`;
